import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Alert,
  Form,
  FormGroup,
  FormInput,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Button,
  FormCheckbox,
} from "shards-react";
import { useRequestHook } from "../../../utils/hooks/hooks";
import Loading from "../../Loading";
import { connect } from "react-redux";

const UserFormModal = ({
  modalData,
  setModalData,
  saveInRedux,
  setUserList,
  currentUserId,
}) => {
  const [loading, setloading] = useState(modalData === "loading");
  const { handleRequest } = useRequestHook(); //Define method to fetch data.
  const [toggleAlert, setToggleAlert] = useState();
  const [toggleDropdown, setToggleDropdown] = useState();
  const [header, setheader] = useState("Daten werden geladen...");
  const [rolesToShow, setRolesToShow] = useState();
  const [localUserData, setLocalUserData] = useState({
    fullName: "",
    uploadName: "",
    email: "",
    settings: {
      registeredJobMail: false,
    },
  });

  /**
   * Handle new user save-button click event.
   */
  const addUser = ({ content }) => {
    if (content.roles.length !== 0) {
      handleRequest("post", "/settings/addUser", { content }, (response) => {
        if (response?.id) {
          setUserList((oldUsersList) => [...oldUsersList, response]);
          setModalData();
        } else {
          handleError(response);
          setloading();
        }
      });
    } else {
      handleError(
        "Bitte wählen Sie mindestens eine Rolle für den Benutzer aus."
      );
      setloading(false);
    }
  };
  /**
   * Handle save-button click event.
   */
  const updateUser = ({ userId, changedData }) => {
    handleRequest(
      "post",
      "/settings/editUserData",
      { userId, changedData },
      (response) => {
        if (response?.id) {
          setUserList((oldUsersList) => {
            return oldUsersList.map((user) => {
              if (user.id === response.id) return response;
              return user;
            });
          });

          if (userId === currentUserId) {
            saveInRedux({
              fullName: response.full_name,
              uploadName: response.upload_name,
              mail: response.mail,
              settings: response.settings,
              roles: response.roles,
            });
          } else {
            setModalData();
          }
        } else {
          handleError(response);
          setloading();
        }
      }
    );
  };
  /**
   * Handle role delete event.
   */
  const handleDeleteRole = ({ roleId }) => {
    if (rolesToShow.map((role) => role._id).includes(roleId)) {
      setRolesToShow((oldState) =>
        oldState.filter((role) => role._id !== roleId)
      );
    } else {
      handleError("Rolle ist nicht im Benutzer enthalten.");
    }
  };
  /**
   * Handle new user name change event.
   */
  const handleFullNameChange = (e) => {
    e.persist();
    setLocalUserData((oldState) => {
      return { ...oldState, fullName: e.target.value };
    });
  };
  /**
   * Handle new user upload-name change event.
   */
  const handleUploadNameChange = (e) => {
    e.persist();
    setLocalUserData((oldState) => {
      return { ...oldState, uploadName: e.target.value };
    });
  };
  /**
   * Handle new user mail change event.
   */
  const handleMailChange = (e) => {
    e.persist();
    setLocalUserData((oldState) => {
      return { ...oldState, email: e.target.value };
    });
  };
  /**
   * Handle new user mail notification change event.
   */
  const handleRegisteredJobMailChange = (e) => {
    e.persist();
    setLocalUserData((oldState) => {
      return {
        ...oldState,
        settings: {
          registeredJobMail: !localUserData.settings.registeredJobMail,
        },
      };
    });
  };
  /**
   * Handle add role to new user event.
   */
  const handleAddRole = (role) => {
    if (rolesToShow.map((role) => role._id).includes(role._id) === false) {
      setRolesToShow((oldState) => {
        return [...oldState, role];
      });
    } else {
      handleError("Rolle ist bereits im Benutzer enthalten.");
    }
  };
  /**
   * Handle error input.
   */
  const handleError = (error) => {
    setToggleAlert(error);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (modalData.userData) {
      setloading(true);
      const changedData = {
        name: localUserData.fullName,
        upload_name: localUserData.uploadName,
        mail: localUserData.email,
        roles: rolesToShow.map((role) => role._id),
        settings: localUserData.settings,
      };
      updateUser({ userId: modalData.userData.id, changedData });
    } else {
      setloading(true);
      const content = {
        name: localUserData.fullName,
        upload_name: localUserData.uploadName,
        mail: localUserData.email,
        roles: rolesToShow.map((role) => role._id),
        settings: localUserData.settings,
      };
      addUser({ content });
    }
  };

  useEffect(() => {
    if (modalData === "loading") return;
    if (!modalData.userData) setheader(() => "Benutzer erstellen");

    if (modalData.userData) {
      setheader(() => modalData.userData.full_name);
      setLocalUserData(() => {
        return {
          fullName: modalData.userData.full_name,
          uploadName: modalData.userData.upload_name,
          email: modalData.userData.mail,
          settings: modalData.userData.settings,
        };
      });
    }

    setRolesToShow(modalData.userRoles ? modalData.userRoles : []);
    setloading(false);
  }, [modalData]);

  return (
    <Modal
      centered
      className="max-width"
      open={modalData !== undefined}
      toggle={() => setModalData()}
    >
      <ModalHeader className="p-3 white-space-pre">{header}</ModalHeader>
      <ModalBody className="p-3">
        <Alert
          theme="danger"
          className="text-center"
          dismissible={() => setToggleAlert()}
          open={toggleAlert !== undefined}
        >
          {toggleAlert}
        </Alert>
        {loading ? (
          <Loading style={{ height: "20vh" }} />
        ) : (
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <label htmlFor="name">Name</label>
              <FormInput
                id="name"
                type="text"
                required
                value={localUserData.fullName}
                placeholder="Max Meier"
                onChange={handleFullNameChange}
              />
            </FormGroup>
            <FormGroup>
              <label htmlFor="upload_name">Name zum hochladen</label>
              <FormInput
                id="upload_name"
                type="text"
                required
                value={localUserData.uploadName}
                placeholder="MMeier"
                onChange={handleUploadNameChange}
              />
            </FormGroup>
            <FormGroup>
              <label htmlFor="mail">E-Mail</label>
              <FormInput
                id="mail"
                type="email"
                required
                value={localUserData.email}
                placeholder="m.meier@example.com"
                onChange={handleMailChange}
              />
            </FormGroup>
            {/* <FormGroup>
							<FormCheckbox id='registered_job_mail' toggle checked={localUserData.settings.registeredJobMail} onChange={handleRegisteredJobMailChange}>
								E-Mail Benachrichtigungen
							</FormCheckbox>
						</FormGroup> */}
            <FormGroup>
              Rollen
              <Dropdown
                className="ml-3 d-inline"
                open={toggleDropdown}
                toggle={() => {
                  if (toggleAlert) setToggleAlert();
                  setToggleDropdown((oldState) => !oldState);
                }}
              >
                <DropdownToggle
                  tag="i"
                  className="p-1 fas fa-plus-circle text-success pointer mb-2 align-middle"
                  style={{ fontSize: "large" }}
                />
                <DropdownMenu>
                  {modalData.mandantRoles.map((role, roleIndex) => (
                    <DropdownItem
                      key={roleIndex}
                      onClick={() => handleAddRole(role)}
                    >
                      <strong className="mr-1">{role.name}</strong>({role._id})
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              {rolesToShow &&
                rolesToShow.map((role, roleIndex) => (
                  <InputGroup key={roleIndex} className="mb-2">
                    <InputGroupText className="flex-grow-1">
                      <strong className="text-dark mr-1">{role.name}</strong>
                      <span className="ml-auto">({role._id})</span>
                    </InputGroupText>
                    <InputGroupAddon type="append">
                      <Button
                        theme="danger"
                        onClick={() => handleDeleteRole({ roleId: role._id })}
                      >
                        löschen
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                ))}
            </FormGroup>
            <Button theme="success" type="submit">
              Speichern
            </Button>
          </Form>
        )}
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = ({ userData: { id: currentUserId } }) => ({
  currentUserId,
});

export default connect(mapStateToProps)(UserFormModal);
